import r from "dayjs";
const i = (t) => t.format("YYYY-MM-DD"), s = (t) => t.format("YYYY-MM-DD HH:mm"), Y = (t) => {
  const m = r().format("YYYY-MM") + "T" + t, o = r(m);
  return o.minute() === 0 ? o.format("HH") : o.format("HH:mm");
};
export {
  i as dayjsToDateString,
  s as dayjsToDateTimeString,
  Y as formatTimeWithOptionalMinutes
};
